<template>
  <el-dialog
      direction="rtl"
      size="80%"
      class="global-dialog"
      destroy-on-close
      :show-close="false"
      :close-on-click-modal="false"
      :title="Lang.Title.dimensionLinkDevice"
      width="796px"
      v-model="selectDeviceDialog"
    >
    <template #header>
      <header v-if="title">
        <span class="dialog-title">{{ title }}</span>
      </header>
      <div style="width: 50%;margin: 10px; display: flex;">
        <CompSearch placeholder="ID"
          v-model="search.sid"
          style="margin-right: 12px;"
          @change=" (val) => { this.onLoad(this.page, this.search) }"
          >
        </CompSearch>
        <CompSearch :placeholder="this.Lang.Title.standardPointPoint"
          v-model="search.name"
          @change=" (val) => { this.onLoad(this.page, this.search) }"
          >
        </CompSearch>
      </div>
    </template>
    <CompTable
      class="global-table"
      :data="data"
      :columns="column"
      :total="page.total"
      :page="page.currentPage"
      :page-size="page.pageSize"
      header-bg-color="#F9FAFB"
      header-text-color="#616D7C"
      :header-max-lines="2"
      :showPagination="false"
      :actionColumnWidth="80"
      height="60vh"
      max-height="60vh"
      actionLabel="Storage"
      :default-sort="{ prop: 'time', order: 'descending' }"
    >
      <template #select="{ row }">
        <CompRadio 
          v-model="row.frontEnd_select" 
          label=""
          allow-uncheck
          @change="(val) => handleSelect(val, row)"
        />
      </template>
    </CompTable>
    
    <template #footer>
      <div style="margin: 10px 20px;">
        <el-pagination
          background
          v-model:current-page="page.currentPage"
          :page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, ->, prev, pager, next, jumper"
          @size-change="sizeChange"
          @current-change="currentChange"
        />
      </div>
      <div style="display: flex; justify-content: center; width: 100%">
        <comp-button size="large" type="default" @click="onCancel()">{{ Lang.btn.cancel }}</comp-button>
        <comp-button size="large" type="primary" @click="confirmSelectRtu()">{{ Lang.btn.confirm }}</comp-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import {
  getPage,
} from '@/api/gateway/data';
import { mapGetters } from 'vuex';
import { getLanguage, Lang } from '@/lang/lang';
import CompRadio from '@/components/comp-radio/index.vue';
import { getDictionary } from '@/api/system/dict';
import CompSearch from '@/components/comp-search/index.vue';
import CompTable from '@/components/comp-table/index.vue';

export default {
  name: 'SelectMeasurementPoint',
  props: {
    selectedPoints: {
      type: Array,
      default() {
        return [];
      },
    },
    isView: {
      type: Boolean,
      default: false,
    },
    dimensionType: {
      type: String,
      default: ''
    },
    rtuId: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
  },
  components: {
    CompRadio,
    CompSearch,
    CompTable
  },
  data() {
    return {
      selectAll: false,
      selectDeviceDialog: true,
      currentLangKey: this.language,
      tableKey: 0,
      form: {},
      commStatusList: [],
      selectionList: [],
      query: {},
      search: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      direction: 'rtl',
      scopeLoading: false,
      menu: true,
      data: [],
      column: [
        {
          label: '',
          prop: 'select',
          slotName: 'select',
          slot: true
        },
        {
            label: 'ID',
            prop: 'sid',
            search: true,
            editDisplay: false,
            viewDisplay: false,
            addDisplay: false,
          },
          {
            label: this.Lang.Title.standardPointType,
            prop: 'stype',
            search: false,
            type: 'select',
            dicUrl: '/blade-system/dict/dictionary?code=typesOfTelemetering',
            dataType: 'string',
            props: {
              label: 'i18nValue',
              value: 'dictKey',
            },
          },
          {
            label: this.Lang.Title.standardPointPoint,
            prop: 'name',
            search: true,
          },
          {
            label: this.Lang.Title.standardPointFormat,
            prop: 'datatypeName',
            search: false,
          },
          {
            label: this.Lang.Title.modelUnit,
            prop: 'unit',
            search: false,
          },
        ],
    };
  },

  computed: {
    ...mapGetters(['menuItem', 'permission', 'language']),
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
        }
      }))
      console.log('页面权限', obj)
      return obj
    },
  },
  created() {
    this.getCommStatusList()
  },
  mounted() {
    this.search.language = this.language; // 默认当前语言
    this.searchReset();
  },
  methods: {
    confirmSelectRtu() {
      this.$emit('confirmSelectRtu', this.selectionList);
      // this.selectDeviceDialog = false;
    },
    onCancel() {
      this.$emit('onCancel')
    },
    getCommStatusList() {
      getDictionary({code: 'commStatus'}).then(res => {
        const data = res.data.data;
        this.commStatusList = data;
      })
    },
    selectionChange(list) {
      // 遍历新选择的列表，只有不在 this.selectionList 中的数据才添加
      list.forEach((item) => {
        const exists = this.selectionList.some((selected) => selected.id === item.id);
        if (!exists) {
          this.selectionList.push(item);
        }
      });
      console.log('selectionChange this.selectionList', this.selectionList);
    },
    handleSelect(val, row) {
      this.data.forEach(item => {
        if (item.id != row.id) {
          item.frontEnd_select = false;
        }
      })
      if (val) {
        this.selectionList = [row]
      }
    },
    selectionClear() {
      this.selectionList = [];
    },
    getSelectedDevice() {
      const selectedDevice = this.selectionList;
      return selectedDevice;
    },
    searchReset() {
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.onLoad(this.page, params);
      done();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.searchReset()
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.searchReset()
    },
    onLoad(page, params = {}) {
      this.scopeLoading = true;
      const values = {
        ...params,
        rtuId: this.rtuId,
      };
      getPage(page.currentPage, page.pageSize, Object.assign(values, this.query), this.currentLangKey).then(
        res => {
          const data = res.data.data || {};
          this.page.total = data.pages.total || 0;
          this.data = data.pages.records || [];
          this.scopeLoading = false;
          // this.selectionClear(); // 跳转第二页保留上次所选
        }
      );
    },
  },
};
</script>
